<footer class="footer text-center">
  <ul class="footer-menu">
    @for (menu of sidebarService.getMenu(); track menu) {
      <div class="hover">
        @for (submenu of menu.submenu; track submenu) {
          <li class="pointer">
            <a
              (click)="footerShowSection(submenu.url)"
              routerLinkActive="active"
              class="footer-menu__links"
              [routerLink]="[submenu.url]"
            >
              <img [src]="submenu.icono" alt="submenu.titulo" />
              <span class="text-footer field-title">
                {{ submenu.titulo }}
              </span>
            </a>
          </li>
        }
      </div>
    }
  </ul>
</footer>
